/**
 * @file Application routes.
 * @description Declares public/protected route tree and default redirects for the app shell.
 * @author Sanjay Jangid (Jiggle frontend)
 * @email sanjay.jangid@dgtoohl.com
 * @date 2026-05-10
 * @version 0.0.0
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../components/Layout';
import Dashboard from '../pages/Dashboard';
import LeadsView from '../pages/leads/LeadsView';
import LeadsUpload from '../pages/leads/LeadsUpload';
import LeadsExport from '../pages/leads/LeadsExport';
import Campaigns from '../pages/campaigns/Campaigns';
import SourceCreate from '../pages/sources/SourceCreate';
import Advertisers from '../pages/advertisers/Advertisers';
import Settings from '../pages/Settings';
import Login from '../pages/Login';
import CorsTest from '../pages/CorsTest';
import LeadUploadFiles from '../pages/lead_upload_files';
import DuplicateFiles from '../pages/duplicate_files';
import { PublicOnlyRoute, RequireAuth } from './RouteGuards';

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnlyRoute>
            <Login />
          </PublicOnlyRoute>
        }
      />

      <Route
        path="*"
        element={
          <RequireAuth>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/leads/view" element={<LeadsView />} />
                <Route path="/leads/upload" element={<LeadsUpload />} />
                <Route path="/leads/export" element={<LeadsExport />} />
                <Route path="/lead-Upload-Files" element={<LeadUploadFiles />} />
                <Route path="/duplicate-files" element={<DuplicateFiles />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/sources/create" element={<SourceCreate />} />
                <Route path="/advertisers" element={<Advertisers />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/cors-test" element={<CorsTest />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
